import React from "react";
import { FieldRenderProps } from "react-final-form";

import styles from "./RangeInput.module.css";

type Props = FieldRenderProps<string, any> & {
  unanswered?: boolean;
  unit?: string;
  min?: string;
  max?: string;
  className?: string;
};

const RangeInput: React.FC<Props> = ({
  input,
  meta,
  unanswered = false,
  unit = "",
  min,
  max,
  className = "",
  ...rest
}: Props) => {
  const hasVisibleError = (meta.error || meta.submitError) && meta.touched;
  const stateClassName = hasVisibleError
    ? styles.errorInputField
    : styles.inputField;
  const numericMin = Number(min ?? 0);
  const numericMax = Number(max ?? 100);
  const numericValue = Number(input.value);
  const progress =
    unanswered || Number.isNaN(numericValue) || numericMax <= numericMin
      ? 0
      : Math.min(
          100,
          Math.max(
            0,
            ((numericValue - numericMin) / (numericMax - numericMin)) * 100,
          ),
        );
  const rangeStyle = {
    "--range-progress": `${progress}%`,
  } as React.CSSProperties;

  return (
    <div className={styles.inputWrapper}>
      <div className={styles.inputLabel}>
        {min}
        {unit}
      </div>
      <input
        className={`${stateClassName} ${className} ${styles.rangeInputField} ${
          unanswered ? styles.unansweredInputField : ""
        }`}
        style={rangeStyle}
        type="range"
        {...input}
        {...rest}
        min={min}
        max={max}
        data-unanswered={unanswered ? "true" : "false"}
      />
      <div className={styles.inputLabel}>
        {max}
        {unit}
      </div>
      {hasVisibleError && (
        <span className={styles.errorText}>{meta.error || meta.submitError}</span>
      )}
    </div>
  );
};

export { RangeInput };
